export const SideBarNavItems = [
    {
        name: "What's New",
        key: "top-nav-item-1",
        link: "/changelog",
        children: true,
        leftIcon: "sparkles",
    },
    {
        name: "Getting Started",
        key: "top-nav-item-2",
        link: "/guides/getting_started",
        children: true,
        leftIcon:"flag"
    },
    {
        name: "Components",
        key: "top-nav-item-3",
        link: "/kits",
        children: true,
        leftIcon:"grid-2"
    },
    {
        name: "Global Props",
        key: "top-nav-item-4",
        link: "/global_props",
        children: true,
        leftIcon:"globe"
    },
    {
        name: "Global Event Props",
        key: "top-nav-item-10",
        link: "/global_event_props",
        children: true,
        leftIcon:"arrow-pointer"
    },
    {
        name: "Tokens",
        key: "top-nav-item-8",
        link: "/tokens",
        children: true,
        leftIcon:"shapes"
    },
    {
        name: "Design Guidelines",
        key: "top-nav-item-5",
        link: "/guides/design_guidelines",
        children: true,
        leftIcon:"palette"
    },
    {
        name: "Icons",
        key: "top-nav-item-7",
        link: "/icons",
        children: false,
        leftIcon:"icons"
    },
    {
        name: "Playground",
        key: "top-nav-item-9",
        link: "/playground",
        children: false,
        leftIcon:"code"
    }
]
